//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'WorkflowSectionVue',
  components: {
    ElSlider: () => import('@/components/common/Slider'),
  },
  data() {
    return {
      options: {
        loop: true,
        duration: 1000,
        spacing: 15,
        dragStart: () => {
          this.setPause(true)
        },
        dragEnd: () => {
          this.setPause(false)
        },
      },
      showSlider: false,
      current: 1,
      sliderSize: 0,
      pause: false,
      interval: null,
      workflowList: [
        {
          index: 1,
          img: () =>
            require(`~/assets/img/partner/main/workflow-section/workflow1.png`),
          title: this.$getTextSetting('reachPrinciplesScreenItem1Title'),
          description: this.$getTextSetting('reachPrinciplesScreenItem1Text'),
        },
        {
          index: 2,
          img: () => {
            const alternativeImage = this.$getBullets(
              'reachPrinciplesScreenPicture2'
            )
            if (alternativeImage[0]) {
              return alternativeImage[0].url
            }

            return require(`~/assets/img/partner/main/workflow-section/workflow2.png`)
          },
          title: this.$getTextSetting('reachPrinciplesScreenItem2Title'),
          description: this.$getTextSetting('reachPrinciplesScreenItem2Text'),
        },
        {
          index: 3,
          img: () => {
            const alternativeImage = this.$getBullets(
              'reachPrinciplesScreenPicture3'
            )
            if (alternativeImage[0]) {
              return alternativeImage[0].url
            }

            return require(`~/assets/img/partner/main/workflow-section/workflow3.png`)
          },
          title: this.$getTextSetting('reachPrinciplesScreenItem3Title'),
          description: this.$getTextSetting('reachPrinciplesScreenItem3Text'),
        },
      ],
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize, true)
    this.resize()
  },
  beforeDestroy() {
    if (this.$refs.slider) {
      this.$refs.slider.slider.destroy()
      this.resetInterval()
    }
  },
  methods: {
    async resize() {
      if (window.innerWidth < 640) {
        if (this.showSlider === false) {
          this.showSlider = true
          await this.$nextTick()
          this.options.slideChanged = (s) => {
            this.current = s.details().relativeSlide
          }
          if (this.$refs.slider) {
            this.$refs.slider.slider.refresh(this.options)
            this.sliderSize = this.$refs.slider.slider.details().size
            this.setInterval()
          }
        }
      } else {
        this.resetInterval()
        this.showSlider = false
      }
    },
    setPause(active) {
      this.pause = active
      this.setInterval()
    },
    resetInterval() {
      clearInterval(this.interval)
    },
    setInterval() {
      if (this.$refs.slider) {
        this.resetInterval()
        this.interval = setInterval(() => {
          if (!this.pause) {
            this.$refs.slider.slider.next()
          }
        }, 3000)
      }
    },
    getDirection() {
      return this.$direction()
    },
  },
}
